
import { mapState } from 'vuex'

export default {    
    async fetch() {
        await this.$store.dispatch('jsonloader/fetchJson', `planning.json`)

        await this.$axios
            .$get(`/api/v1/content/landing-page?url=${this.$route.path}`)
            .then((res) => {
                this.model = res.data
                this.pageType = 'page'
            })
            .finally(() => {
                if (!this.model) this.pageType = 'content-type'
            })
    },

    data() {
        return {
            pageType: null,
            model: null,
        }
    },

    computed: {
        ...mapState({
            contentTypes: (state) => state.data.contentTypes || [],
        }),

        contentTypeId() {
            return this.contentTypes
                .reduce((acc, el) => {
                    acc.push(el)
                    if (el.children.length) acc = [...acc, ...el.children]
                    return acc
                }, [])
                .find((el) => el.slug === this.$route.params.taxonomy)?.id
        },
    },

    watch: {
        $route: '$fetch',
    },
}
